import React from 'react';

import { MAP_ZOOM_DELAY_MS } from '../../constants';
import { useMRE } from '../../hooks/useMRE';
import { useMREState } from '../../hooks/useMREState';
import { ZoomSpeed } from '../../types';

import styles from './MapViewControls.module.scss';

export const MapViewControls = () => {
  const { track, t } = useMRE();
  const { setZoomSpeed } = useMREState();

  const onZoomIn = () => {
    setZoomSpeed(ZoomSpeed.ZoomIn);
    setTimeout(() => {
      setZoomSpeed(ZoomSpeed.ZoomStop);
    }, MAP_ZOOM_DELAY_MS);

    // Track the zoom in action
    track({
      action: 'click',
      element: 'map_view_controls',
      properties: {
        zoom: 'in'
      }
    });
  };

  const onZoomOut = () => {
    setZoomSpeed(ZoomSpeed.ZoomOut);
    setTimeout(() => {
      setZoomSpeed(ZoomSpeed.ZoomStop);
    }, MAP_ZOOM_DELAY_MS);

    // Track the zoom out action
    track({
      action: 'click',
      element: 'map_view_controls',
      properties: {
        zoom: 'out'
      }
    });
  };

  if (!setZoomSpeed) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.controls}>
        <button
          className={styles.control}
          onClick={onZoomIn}
          title={t('mre.view_controls.zoom_in')}
          data-testid="mre-zoom-in-button"
        >
          <span className={styles.zoomIn}></span>
        </button>
        <button
          className={styles.control}
          onClick={onZoomOut}
          title={t('mre.view_controls.zoom_out')}
          data-testid="mre-zoom-out-button"
        >
          <span className={styles.zoomOut}></span>
        </button>
      </div>
    </div>
  );
};
